<template>
  <div class="block-information clearfix" v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java.png">
    </div>
    <div class="fl">
      <span class="angle"></span>
      <div style="display:flex;">
      <div class="tit" @click="$router.push(`/`)" style="border-bottom: 2px solid #e37200;">
        {{$t("HyperBlockList")}}
      </div>
      <div class="tit" style="margin-left:30px;font-size:16px;line-height: 32px;"  @click="$router.push(`/TxList`)">
        Transactions
      </div>  
     </div> 
      <section id="tab" class="section2">
        <div style="width: 100%;">
          <table class="table">
            <tr>
              <th v-text="$t('HBlock')"></th>
              <!-- HBlock -->
              <th v-text="$t('LChains')"></th>
              <!-- LChains -->
              <th v-text="$t('Blocks')"></th>
              <th v-text="$t('Apps')"></th>
              <th v-text="$t('Time')"></th>
            </tr>
            <tr
            v-for="(item,index) in hyperblocks"
            :key="index"
            @click="$router.push(`/HyperblockView/${item.Hyperblock}`)">
              <td>
                <a href="javascript:;" v-text="item.Hyperblock">
                </a>
              </td>
              <td>{{item.chains}}</td>
              <td>{{item.Blocks}}</td>
              <td>{{item.apps}}</td>
              <td>{{$retTime(item.time*1000)}}</td>
            </tr>
          </table>
        </div>
      </section>
      <pages
        toLink="BrowserHome"
        :pageCount="pageCount"
        :page="page">
      </pages>
    </div>
  </div>
</template>
<script>
import pages from '@/components/pages.vue'
export default {
  components:{
    pages
  },
  data(){
    return{
      pageCount:'',
      hyperblocks:[],
      page:1,
      loading: true,
    }
  },
  watch:{
    $route(){
      this.init();
    }
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      this.$http({
        url:`hyperchain/home?page=${this.$route.params.page}&pageSize=10`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.ret == 200){
          this.hyperblocks = data.data.data;
          this.pageCount = data.data.pages.pageCount;
          if(data.data.pages.page<1){
            this.page = 1;
          }else{
            this.page = data.data.pages.page;
          }
        }
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .section2 .table{
      width: 500px!important;
    }
  }
</style>
